<template>
    <div class="mass-update-modal">
        <div class="container daily-activity__wrap">
            <label class="activity-title"><h5>Select Activity:</h5></label>
            <div class="daily-activity">
                <el-form>
                    <el-form-item label="Activity">
                        <el-select v-model="ddlTaskDescription" @change="TaskDescription()"
                                   placeholder="Select" :disabled="!isNew">
                            <el-option key="Rest" label="Rest" value="Rest"></el-option>
                            <el-option key="Feed" label="Feed" value="Feed"></el-option>
                            <el-option key="Poop" label="Poop" value="Poop"></el-option>
                            <el-option key="Hygiene" label="Hygiene" value="Hygiene"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Rest Type" v-if="selectionRest" :disabled="!isNew">
                        <el-select v-model="ddlRest" placeholder="Select">
                            <el-option key="Nap" label="Nap" value="Nap"></el-option>
                            <el-option key="Sleep" label="Sleep" value="Sleep"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Feed Type" v-if="selectionFeed" :disabled="!isNew">
                        <el-select v-model="ddlFeed" @change="TaskDescription()" placeholder="Select">
                            <el-option key="Bottle-Type" label="Bottle-Type"
                                       value="Bottle-Type"></el-option>
                            <el-option key="Solid" label="Solid" value="Solid"></el-option>
                            <el-option key="Latch On" label="Latch On" value="Latch On"></el-option>
                            <el-option key="Menu" label="Menu" value="Menu"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Bottle-Type" v-if="selectionFeedBottleType && selectionFeed" :disabled="!isNew">
                        <el-select v-model="ddlFeedBottleType" placeholder="Select">
                            <el-option key="Formula" label="Formula" value="Formula"></el-option>
                            <el-option key="Breast Milk" label="Breast Milk"
                                       value="Breast Milk"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Latch Side" v-if="selectionLatchOn && selectionFeed" :disabled="!isNew">
                        <el-select v-model="ddlLatchOn" placeholder="Latch On">
                            <el-option key="Left" label="Left" value="Left"></el-option>
                            <el-option key="Right" label="Right" value="Right"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Poop Detail" v-if="selectionPoop">
                        <el-select v-model="ddlPoop" @change="TaskDescription()" placeholder="Select" :disabled="!isNew">
                            <el-option key="Texture" label="Texture" value="Texture"></el-option>
                            <el-option key="Color" label="Color" value="Color"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Texture Type" v-if="selectionTexture && selectionPoop">
                        <el-select v-model="ddlTexture" placeholder="Select" :disabled="!isNew">
                            <el-option key="Creamy" label="Creamy" value="Creamy"></el-option>
                            <el-option key="Firm" label="Firm" value="Firm"></el-option>
                            <el-option key="Hard" label="Hard" value="Hard"></el-option>
                            <el-option key="Watery" label="Watery" value="Watery"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Poop Color" v-if="selectionColor && selectionPoop">
                        <el-select v-model="ddlColor" placeholder="Select" :disabled="!isNew">
                            <el-option key="Brown" label="Brown" value="Brown"></el-option>
                            <el-option key="Tan" label="Tan" value="Tan"></el-option>
                            <el-option key="Yellow" label="Yellow" value="Yellow"></el-option>
                            <el-option key="Green" label="Green" value="Green"></el-option>
                            <el-option key="Black" label="Black" value="Black"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Hygiene Activity" v-if="selectionHygiene">
                        <el-select v-model="ddlHygiene" placeholder="Select" :disabled="!isNew">
                            <el-option key="Diaper change" label="Diaper change"
                                       value="Diaper change"></el-option>
<!--                            <el-option key="Shower&Diaper change" label="Shower&Diaper change"-->
<!--                                       value="Shower&Diaper change"></el-option>-->
<!--                            <el-option key="Shower" label="Shower" value="Shower"></el-option>-->
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Start" v-if="selectionCurrentTime">
                        <el-time-select
                                placeholder="Get current time"
                                v-model="txtTimeStart" :disabled="!isNew"
                        >
                        </el-time-select>
                    </el-form-item>
                    <el-form-item label="Start" v-if="selectionStartEndTime">
                        <el-time-select
                                placeholder="Get Start time"
                                v-model="txtTimeStart"
                                :picker-options="{
                            start: '08:30',
                            step: '00:10',
                            end: '20:30'
                            }"
                                :disabled="!isNew">
                        </el-time-select>
                    </el-form-item>
                    <el-form-item label="End" v-if="selectionStartEndTime">
                        <el-time-select
                                placeholder="End time"
                                v-model="txtTimeStop"
                                :picker-options="{
                            start: '08:30',
                            step: '00:10',
                            end: '20:30',
                            minTime: txtTimeStart
                            }"
                                :disabled="!isNew">
                        </el-time-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="selectionRemark" class="daily-remark  mb-3 ">
                <label class="text-left">Remark:</label>
                <el-input class="" v-model="txtRemark"></el-input>
                <b-button @click="btnUpdate" v-if="!isNew">Update</b-button>
                <b-button @click="compBtnAdd" v-if="isNew">Add</b-button>
            </div>
        </div>
    </div>
</template>
<script>
    import DataSource from "../../data/datasource";
    import Cookies from "js-cookie";
    import moment from 'moment';
    import $ from "jquery";

    export default {
        name: "Mass_Update_Table",
        data() {
            return {
                studentID: "",
                routine: "",
                ddlTaskDescription: '',
                txtTimeStart: '',
                txtTimeStop: '',
                txtTimeCurrent: '',
                txtRemark: '',
                ddlRest: '',
                ddlFeed: '',
                ddlFeedBottleType: '',
                ddlLatchOn: '',
                ddlPoop: '',
                ddlTexture: '',
                ddlColor: '',
                ddlHygiene: '',
                selectionRest: '',
                selectionStartEndTime: '',
                selectionCurrentTime: '',
                selectionRemark: '',
                selectionFeed: '',
                selectionFeedBottleType: '',
                selectionLatchOn: '',
                selectionPoop: '',
                selectionTexture: '',
                selectionColor: '',
                selectionHygiene: '',
                isNew: false,
            };
        },
        mounted() {
            this.initEvent();
        },
        props: ["Routine", "emitStudentID"],
        methods: {
            async initEvent() {
                this.studentID = this.emitStudentID;
                if (this.Routine === "") {
                    this.isNew = true;
                } else {
                    this.isEditRoutine();
                }
            },
            isEditRoutine() {
                this.routine = this.Routine;
                let tempRoutine = this.routine.DrReferenceType.split("|");

                this.ddlTaskDescription = tempRoutine[0];

                if (tempRoutine[0] === "Rest") {
                    this.ddlRest = tempRoutine[1];
                } else if (tempRoutine[0] === "Feed") {
                    this.ddlFeed = tempRoutine[1];
                    if (this.ddlFeed === "Bottle-Type") {
                        this.ddlFeedBottleType = tempRoutine[2];
                    } else if (this.ddlFeed === "Latch On") {
                        this.ddlLatchOn = tempRoutine[2];
                    }
                } else if (tempRoutine[0] === "Poop") {
                    this.ddlPoop = tempRoutine[1];
                    if (this.ddlPoop === "Texture") {
                        this.ddlTexture = tempRoutine[2];
                    } else if (this.ddlPoop === "Color") {
                        this.ddlColor = tempRoutine[2];
                    }
                } else if (tempRoutine[0] === "Hygiene") {
                    this.ddlHygiene = tempRoutine[1];
                }
                this.txtTimeStart = moment(this.routine.DrStartTime).format("HH:mm");
                this.txtTimeStop = moment(this.routine.DrEndTime).format("HH:mm");
                this.txtRemark = this.routine.DrRemark;
                this.TaskDescription();
            },
            TaskDescription() {
                this.selectionRest = false;
                this.selectionStartEndTime = false;
                this.selectionCurrentTime = false;
                this.selectionFeed = false;
                this.selectionFeedBottleType = false;
                this.selectionLatchOn = false;
                this.selectionPoop = false;
                this.selectionTexture = false;
                this.selectionColor = false;
                this.selectionHygiene = false;
                this.selectionCurrentTime = false;
                this.selectionRemark = true;
                if (this.ddlTaskDescription === 'Rest') {
                    this.selectionRest = true;
                    this.selectionStartEndTime = true;
                } else if (this.ddlTaskDescription === 'Feed') {
                    this.selectionCurrentTime = true;
                    this.selectionFeed = true;
                    this.selectionFeedBottleType = false;
                    this.selectionLatchOn = false;

                    if (this.ddlFeed === "Bottle-Type") {
                        this.selectionFeedBottleType = true;
                    } else if (this.ddlFeed === "Latch On") {
                        this.selectionLatchOn = true;
                    }
                } else if (this.ddlTaskDescription === 'Poop') {
                    this.selectionPoop = true;
                    this.selectionTexture = false;
                    this.selectionColor = false;

                    if (this.ddlPoop === "Texture") {
                        this.selectionTexture = true;
                    } else if (this.ddlPoop === "Color") {
                        this.selectionColor = true;
                    }
                } else if (this.ddlTaskDescription === 'Hygiene') {
                    this.selectionHygiene = true;
                    this.selectionCurrentTime = true;
                }
            },
            async btnUpdate() {
                try {
                    //if no checkbox is checked, pop up alert
                    let btnUpdateObject = [];
                    btnUpdateObject.DrStudentID = this.studentID;
                    btnUpdateObject.drID = this.routine.DrID;
                    btnUpdateObject.drRemark = this.txtRemark;
                    const response = await DataSource.shared.updateDailyRoutine(btnUpdateObject);
                    if (response) {
                        switch (response.code) {
                            case "1":
                                this.$notify({
                                    title: 'Success',
                                    message: 'Activity Updated',
                                    type: 'success'
                                });
                                this.refreshStudentActivity();
                                break;
                        }
                    }
                } catch (exception) {
                    alert(exception);
                }
            },
            async compBtnAdd() {
                try {
                    this.$vs.loading();
                    let drReferenceType = '';
                    if (this.selectionRest === true) {
                        if (this.ddlRest === "Nap") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlRest;

                        } else if (this.ddlRest === "Sleep") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlRest;
                        }
                    } else if (this.selectionFeed === true) {
                        if (this.selectionFeedBottleType === true) {
                            if (this.ddlFeedBottleType === "Formula") {
                                drReferenceType = this.ddlTaskDescription + "|" + this.ddlFeed + "|" + this.ddlFeedBottleType;
                            } else if (this.ddlFeedBottleType === "Breast Milk") {
                                drReferenceType = this.ddlTaskDescription + "|" + this.ddlFeed + "|" + this.ddlFeedBottleType;
                            }
                        } else if (this.ddlFeed === "Solid") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlFeed;
                        } else if (this.selectionLatchOn === true) {
                            if (this.ddlLatchOn === "Left") {
                                drReferenceType = this.ddlTaskDescription + "|" + this.ddlFeed + "|" + this.ddlLatchOn;
                            } else if (this.ddlLatchOn === "Right") {
                                drReferenceType = this.ddlTaskDescription + "|" + this.ddlFeed + "|" + this.ddlLatchOn;
                            }

                        } else if (this.ddlFeed === "Menu") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlFeed;
                        }

                    } else if (this.selectionPoop === true) {
                        if (this.selectionTexture === true) {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlPoop + "|" + this.ddlTexture;
                        } else if (this.selectionColor === true) {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlPoop + "|" + this.ddlColor;
                        }

                    } else if (this.selectionHygiene === true) {
                        if (this.ddlHygiene === "Diaper change") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlHygiene;
                        } else if (this.ddlHygiene === "Shower&Diaper change") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlHygiene;
                        } else if (this.ddlHygiene === "Shower") {
                            drReferenceType = this.ddlTaskDescription + "|" + this.ddlHygiene;
                        }

                    }

                    let btnAddObject = [];
                    btnAddObject.DrStartTime = this.txtTimeStart;
                    btnAddObject.DrEndTime = this.txtTimeStop;
                    btnAddObject.DrRemark = this.txtRemark;
                    btnAddObject.studentIDArray = this.studentID;
                    btnAddObject.DrReferenceType = drReferenceType;

                    if (this.selectionRest === true && this.txtTimeStop === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else if (this.selectionRest === true && this.txtTimeStart === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else if (this.selectionFeed === true && this.txtTimeStart === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else if (this.selectionHygiene === true && this.txtTimeStart === "") {
                        this.$notify.error({
                            title: 'Error',
                            message: 'Please fill in content'
                        });
                    } else {
                        const resp = DataSource.shared.addDailyRoutine(btnAddObject);
                        resp.then((resp) => {

                            if (resp.code === '1') {
                                this.$notify({
                                    title: 'Success',
                                    message: 'Task added.',
                                    type: 'success'
                                });
                                this.refreshStudentActivity();
                            } else {
                                this.$notify.error({
                                    title: 'Error',
                                    message: 'Error'
                                });
                            }
                        });
                    }
                    await this.sleep(1000);
                    this.$vs.loading.close();
                } catch (e) {
                    alert(e);
                    console.log(e);
                }
            },
            sleep(milliseconds) {
                return new Promise(resolve => setTimeout(resolve, milliseconds));
            },
            refreshStudentActivity() {
                this.$emit('refreshStudentActivity');
                this.$emit('hideUpdateModal');
            }
        }

    };
</script>
<style>
    .mass-update-modal .el-date-editor.el-input input:disabled, .daily-activity .el-select input:disabled {
        background: #da5c5c !important;
        border: 0px;
        color: #943c3c !important;
        font-weight: bold;
    }

    .mass-update-modal .daily-remark input {
        margin: 0px 0px 15px;
    }

    .mass-update-modal .daily-activity .el-form-item:last-child .el-date-editor {
        margin-right: 0px;
    }
</style>
<style scoped>
</style>